export const LOGIN = "/users/login"

export const USERS = "/usersAdmin"

export const UPDATE_USER_STATUS = "/usersAdmin/userStatus"

export const COMPANIES = "/companies"
